import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['user', 'work']),
        getPermByProject: (state, getters, rootState, rootGetters) => (project) => {
            const userId = rootState.auth.user.idWorldUser;
            let permission = 10;
            if(Object.keys(project).length > 0) {
                project.developers.forEach(workId => {
                    if(getters['get'](userId + '-' + workId) && getters['get'](userId + '-' + workId).permission < permission){
                        permission = getters['get'](userId + '-' + workId).permission;
                    }
                });
            }
            return permission;
        },
        getPermByWork: (state, getters, rootState) => (workId) => {
            if(workId === 'my'){
                return '1';
            } else {
                const employment = getters['get'](rootState.auth.user.idWorldUser + '-' + workId);
                return state.objs.length > 0 && employment? employment.permission : '10';
            }
        },
        getWorks: (state, getters, rootState, rootGetters) => {
            return state.objs.map(e => rootGetters['works/get'](e.work));
        },
        getByUser: (state) => user => {
            return state.objs.filter(e => e.user === user);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['user', 'work'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['user', 'work'])
    },
}